import React, { useState } from 'react';

import './Community.css'

const Community = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    phoneNumber: '',
    choices: [-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1]
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Add signup logic here
    console.log('Signup:', formData);
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <h2>Signup</h2>
        
        <input></input>
        <input></input>
        <input></input>
        <textarea></textarea>
        <textarea></textarea>

        <div className='vibe-choices'>
            <div className='vibe-row'>
                <img src={require('./festival.png')}></img>
                <img src={require('./festival.png')}></img>
            </div> 
            <div className='vibe-row'>
                <img src={require('./festival.png')}></img>
                <img src={require('./festival.png')}></img>
            </div>
        </div>
        
        <button type="submit" secondary large>
          Signup
        </button>
      </form>
    </div>
  );
};

export default Community;

